import SettingsStore from '../stores/settings-store';
import { TabQueryParam } from '../types/settings-types';

export const setCurrentTabValue = (currentTab: TabQueryParam) => {
  SettingsStore.currentTab = currentTab;
};

export const setDefaultTabValue = () => {
  setCurrentTabValue(TabQueryParam.OrgSettings);
};
